// Admin
import AdminAllStore from "@/Stores/Admin/AdminAllStore";
import FileManagerStore from "@/Stores/Admin/FileManagerStore";
// Site
import BasketStoreMobx from "@/Stores/Pages/BasketStoreMobx";
import CatalogStore from "@/Stores/Site/CatalogStore";
import CollectionsStore from "@/Stores/Site/CollectionsStore";
import FavouritesStore from "@/Stores/Pages/FavouritesStore";
import GiftCertificateStore from "@/Stores/Pages/GiftCertificateStore";
import ModalStoreMobx from "@/Stores/Site/ModalStoreMobx";
import NewsStore from "@/Stores/Pages/NewsStore";
import ProfileStore from "@/Stores/Pages/ProfileStore";
// import CountryStore from "@/Stores/Header/CountryStore";
// import MobileMenuStore from "@/Stores/Header/MobileMenuStore";
// import SubMenuStore from "@/Stores/Header/SubMenuStore";

class RootStores {
    constructor() {
        /**
         * Admin
         */
        this.adminAllStore = new AdminAllStore(this);
        this.fileManagerStore = new FileManagerStore(this);

        /**
         * Site
         */
        this.modalStore = new ModalStoreMobx(this);
        this.catalogStore = new CatalogStore(this);
        this.collectionsStore = new CollectionsStore(this);
        this.basketStore = new BasketStoreMobx(this);
        this.favouritesStore = new FavouritesStore(this);
        this.giftCertificateStore = new GiftCertificateStore(this);
        this.newsStore = new NewsStore(this);
        this.profileStore = new ProfileStore(this);

        // this.subMenuStore = new SubMenuStore(this);
        // this.mobileMenuStore = new MobileMenuStore(this);
        // this.countryStore = new CountryStore(this);
    }
}

export default new RootStores();
